import { createContext } from 'react'

const LoadingContext = createContext({
  showSpinner: false,
  showLoading: () => {},
  hideLoading: () => {}
})

export default LoadingContext
